// extracted by mini-css-extract-plugin
export default {"container":"SendToSeagateModal_container__zhaHv","shareEmailBtn":"SendToSeagateModal_shareEmailBtn__708DM","emailSvg":"SendToSeagateModal_emailSvg__RDCBm"};